<template>
  <div class="hm" style="padding-top: 20px;">
    <div class="cpxj-title">课程中心</div>
    <div style="width: 200px;margin: 30px auto 40px;">
      <el-divider><i class="el-icon-s-platform" style="color: #0071BA;font-size: 26px;"></i></el-divider>
    </div>
    <el-card class="box-card" style="width: 1250px;margin: 0 auto 70px;">
      <kczx-info :wjSrc="wjSrc" />
    </el-card>
    <div class="cpxj-title">科普宣传</div>
    <div style="width: 200px;margin: 30px auto 40px;">
      <el-divider><i class="el-icon-s-cooperation" style="color: #0071BA;font-size: 26px;"></i></el-divider>
    </div>
    <el-card class="box-card" style="width: 1300px;margin: 20px auto;">
      <xjzx-info :wjSrc="wjSrc" />
    </el-card>
  </div>
</template>

<script>
  import {
    getItype
  } from '@/assets/js/common.js';
  import KczxInfo from './common/KczxInfo.vue'
  import XjzxInfo from './common/XjzxInfo.vue'
  export default {
    name: 'Home',
    props: ['currentUser', 'isDenglu', 'wjSrc'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('手机号不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('手机号码有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        zyjnFlag: 0,
        zyzcFlag: 0,
        activeName: '001',
        lrkx: {
          margin: '0 15px 10px'
        },
        currentPage1: 5,
        currentPage2: 5,
        currentPage3: 5,
        currentPage4: 4,
        name: '',
        kcBigItype: '',
        kcSmallItype: '',
        priceItype: 'all',
        params: {
          page: 1,
          rows: 12,
          ontype: '',
          zhpx: '',
          xlpx: '',
          jgpx: '',
          keyword: '',
          isguoqi: 0
        },
        tableData: {
          rows: [],
          total: 0
        },
        loading: true,
        options: [],
        smallItypes: []
      }
    },
    methods: {

    },
    created: function() {
      var mainContainer = document.getElementById('app');
      if (mainContainer.scrollTop > 110) {
        mainContainer.scrollTop = 110;
      }
    },
    components: {
      KczxInfo,
      XjzxInfo
    }
  }
</script>

<style>
  .cpxj-title {
    font-size: 36px;
    font-weight: normal;
    font-style: normal;
    color: #000000;
    text-align: center;
  }

  .el-divider__text {
    background-color: rgb(248, 248, 248)!important;
  }

  .itypeBq {
    align-items: center;
    height: 26px;
    margin: 0 auto 20px;
  }

  .itypeBq span {
    margin-right: 38px;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #333;
    cursor: pointer;
  }

  .itypeBq span.active {
    padding: 3px 15px;
    background: #e4f3fc;
    border-radius: 13px;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #0071ba;
  }

  .itypeBq .xx-label {
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 600;
    text-align: left;
    color: #555555;
    margin-left: 22px;
  }

  .px-div {
    width: 100%;
    display: flex;
  }

  .px-div span.sortDiv {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    padding-right: 39px;
    display: flex;
  }

  .sortDiv .sortIcon {
    position: relative;
    width: 15px;
    height: 21px;
    font-size: 14px;
    margin-left: 3px;
  }

  .sortDiv .sortIcon i {
    position: absolute;
    cursor: pointer;
    color: #909399;
  }

  .sortDiv .sortIcon i:first-child {
    top: 0;
  }

  .sortDiv .sortIcon i:last-child {
    bottom: 0;
  }

  .hm-sxTitle {
    margin-bottom: 38px;
  }

  .hm-sxTitle-l.red::before {
    content: " ";
    position: absolute;
    display: inline-block;
    width: 6px;
    height: 25px;
    background: #d50000;
    left: 0;
    top: 4px;
  }

  .hm-sxTitle-l.blue::before {
    content: " ";
    position: absolute;
    display: inline-block;
    width: 6px;
    height: 25px;
    background: #0071BA;
    left: 0;
    top: 4px;
  }

  .hm-sxTitle-l.blue span {
    display: inline-block;
    height: 20px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: center;
    color: #333333;
    line-height: 20px;
    padding-left: 14px;
    cursor: pointer;
  }

  .hm-sxTitle-l.blue span.active {
    color: #0071ba;
  }

  .hm-sxTitle-l.blue .huaxian {
    position: absolute;
    width: 20px;
    height: 0px;
    opacity: 1;
    border: 2px solid #0071ba;
    left: 232px;
    bottom: -10px;
  }

  .hm-sxTitle-l {
    opacity: 1;
    font-size: 24px;
    font-family: 'PingFangSC';
    font-weight: 600;
    text-align: left;
    color: #333333;
    line-height: 33px;
    padding-left: 22px;
    position: relative;

  }

  .hm-sxTitle-r {
    font-size: 18px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #9a9a9a;
    line-height: 33px;
    cursor: pointer;
  }

  .zyjn-every {
    width: 271px;
    height: 305px;
    opacity: 1;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    background-color: #fff;
    transition: all 0.3s linear;
    margin-bottom: 20px;
    margin-right: 32px;
    cursor: pointer;
  }

  .zyjn-every:hover {
    box-shadow: 0 10px 15px #E3E3E3;
    margin-top: -10px;
    transform: rotateY(10deg);
  }

  .zyjn-every img {
    width: 271px;
    height: 174px;
    opacity: 1;
    border-radius: 6px 6px 0px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
  }

  .zyjn-every-tit {
    margin: 10px auto;
    width: 252px;
    height: 22px;
    opacity: 1;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 22px;
    letter-spacing: 1px;
  }

  .kcxc-every-tit{
    margin: 10px auto;
    width: 252px;
    height: 44px;
    opacity: 1;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 22px;
    letter-spacing: 1px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .zyjn-every-yxq {
    width: 252px;
    height: 20px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 20px;
    letter-spacing: 1px;
    margin: 0 auto;
  }

  .zyjn-every-bot {
    width: 249px;
    margin: 10px auto 0;
    border-top: 1px solid #efefef;
    margin-top: 10px;
    line-height: 56px;
  }

  .zyjn-every-bot .zyjn-every-bmrs {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #9a9a9a;
    text-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
  }

  .zyjn-every-bot .zyjn-every-price {
    font-size: 24px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: right;
    color: #d50000;
    letter-spacing: 2px;
    text-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
  }

  .zyjn-every-bot .zyjn-every-mianfei {
    font-size: 24px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
    letter-spacing: 2px;
    text-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
  }

  .gg-banner {
    width: 583px;
    height: 164px;
    border-radius: 4px;
  }

  .gg-banner img {
    width: 583px;
    height: 164px;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Product.vue